import { SurchargeTypeUpdater } from "./surcharge-type-updater.model";

export class SurchargeTypeUpdaterMapper {
  public static map(data: any): SurchargeTypeUpdater {
    if (!data) {
      return;
    }

    return new SurchargeTypeUpdater(
      data.id,
      data.active,
      data.marginPercentage,
      data.shipmentPrice,
      data.pricePer100Kg,
      data.pricePer100KgReal,
      data.pricePerPiece,
      data.pricePerPallet,
      data.minPrice,
      data.maxPrice,
    );
  }
}
